export default {
  'onlineStore.store': 'ショップ',
  'onlineStore.coming_soon': '近日発売',
  'onlineStore.sold_out': '売り切れ',
  'onlineStore.piece': '枚',
  'onlineStore.original_price': '元の価格',
  'onlineStore.empty': '現在、商品はありません',
  'onlineStore.text.building': 'コンテンツ構築中',
  'onlineStore.text.more_information': '詳細はブランド公式サイト/SNSをご覧ください',
  'onlineStore.category': 'カテゴリ',
  'onlineStore.brand': 'ブランド',
  'onlineStore.recommend': 'おすすめ',
  'onlineStore.package': 'パッケージ',
  'onlineStore.my_product': 'お持ちの商品券',
  'onlineStore.12cm.company_name': 'ECHOSS TECHNOLOGY LIMITED',
  'onlineStore.search_placeholder': '商品名で検索',
  'onlineStore.search': '検索',
  'onlineStore.cancel': 'キャンセル',
} as Record<string, string>;
